
<template>
  <div
    id="login"
    class="auth-container text-center bg-light"
  >
    <b-form>
      <img
        class="logo"
        src="../../../assets/images/logo.png"
        alt="uttrly"
      >
      <h1 class="h4 mb-3">
        Forgot Password
      </h1>

      <p class="mb-4 text-muted">
        Enter your email address and we will send you a link to reset your password.
      </p>

      <div>
        <label
          class="sr-only"
          for="email-input"
        >Email address</label>
        <b-input
          id="email-input"
          v-model="email"
          type="email"
          placeholder="Email address"
          :disabled="sending"
        />

        <b-button
          key="login-button"
          variant="primary"
          type="submit"
          class="btn-lg btn-block"
          :disabled="sending || !email"
          @click.prevent="resetPassword"
        >
          Reset Password
          <b-spinner v-if="sending" small label="spinnig" class="ml-1"></b-spinner>
        </b-button>

        <p
          class="copyright mt-4 mb-3 text-muted"
        >
          Dont have an account?
          <b-link
            router-component-name="router-link"
            to="/signup"
          >
            Sign up
          </b-link>
        </p>
      </div>
    </b-form>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useNotification } from '@kyvg/vue3-notification'
import FirebaseService from '@/services/FirebaseService'
import { sendPasswordResetEmail } from 'firebase/auth'

const email = ref('')
const sending = ref(false)
const { notify } = useNotification()

const resetPassword = async () => {
  const auth = await FirebaseService.auth()
  sending.value = true
  const redirectURL = `${window.location.protocol}//${window.location.host}/`
  sendPasswordResetEmail(auth, email.value, { url: redirectURL}).then(() => {
    notify({ type: 'success', title: 'Success', text: 'A password reset email has been sent to your email address.' })
    email.value = ''
  }).catch(() => {
    notify({ type: 'error', title: 'Error', text: 'Error sending password reset email, please try again later.' })
  })
  sending.value = false
}
</script>

<style lang="scss">
.auth-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;

  img.logo {
    margin-bottom: 1.5rem;
  }

  h1 {
    font-weight: 400;
  }

  form {
    width: 100%;
    max-width: 420px;
    padding: 15px;
    margin: auto;

    input#email-input {
      margin-bottom: 1.2rem;
      border-radius: 0;
    }

    .form-control {
      position: relative;
      box-sizing: border-box;
      height: auto;
      padding: 10px;
      font-size: 1rem;
    }
  }
}
</style>
